export default "__VITE_ASSET__BF3xTAs4__"